import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Layout from '../shared/Layout';
import IconGoBack from '../../components/icons/IconGoBack';
import useExerciseTemplateBuilder from './useExerciseTemplateBuilder';
import BuilderHeader from './BuilderHeader';
import BlockList from './BlockList';
import WordPanel from './WordPanel';
import language from '../../variables/language';
import '../../css/exercise-templates.css';
import '../../css/container-layout.css';
import '../../css/media-uploader.css';

export default function Builder() {
   const { id } = useParams();
   const navigate = useNavigate();
   const location = useLocation();
   const { template, elements, interactiveElements, containers, loading, saveTemplateHeader, deleteTemplate, reloadBlocks } = useExerciseTemplateBuilder(id);
   const lang = language[language.lang];
   // Arriving from a course Topic's linked-exercises panel carries a
   // returnTo (e.g. back to that specific course) - falls back to the
   // plain exercise-templates list for the normal entry point.
   const returnTo = location.state && location.state.returnTo ? location.state.returnTo : '/exercise-templates';
   // Media block upload needs a courseId (the upload endpoint is
   // course-scoped - see components/MediaUploader.jsx), which only exists
   // when this Builder was actually opened from a course - derived from
   // the same returnTo rather than a separate param, since that's the only
   // place it's ever available. null when opened directly from
   // /exercise-templates - MediaUploader shows its own explanatory
   // fallback in that case, nothing special needed here.
   const returnToCourseMatch = returnTo.match(/^\/courses\/(\d+)/);
   const courseId = returnToCourseMatch ? returnToCourseMatch[1] : null;

   const handleDelete = () => {
      if(!window.confirm('Чи напевно хочеш видалити цей шаблон вправи ?')) return;
      deleteTemplate();
   };

   return (
      <Layout>
         <main className='main-block'>
            <div className='main-content txt-c exercise-builder-page'>
               <div className='exercise-builder-detail-header'>
                  <div className='exercise-builder-back-btn' onClick={() => navigate(returnTo)} title='Назад'>
                     <IconGoBack />
                  </div>
                  <div className='exercise-builder-detail-title'>{template ? template.name : 'Шаблон вправи'}</div>
               </div>

               {loading ? (
                  <div className='event-edit-loading'>{lang['Loading ...']}</div>
               ) : !template ? (
                  <div className='event-edit-loading'>Шаблон не знайдено</div>
               ) : (
                  <>
                     <BuilderHeader template={template} onSave={saveTemplateHeader} onDelete={handleDelete} />
                     <div className='exercise-builder-body'>
                        <BlockList exerciseId={id} courseId={courseId} elements={elements} interactiveElements={interactiveElements} containers={containers} onReload={reloadBlocks} />
                        <WordPanel exerciseId={id} />
                     </div>
                  </>
               )}
            </div>
         </main>
      </Layout>
   );
}
